import validation from '../../../../../validation/index.js'

const getLatestParamRules = {
  id: validation.rules.string().required().label('Organization ID'),
  productId: validation.rules.string().required().label('Product ID'),
}

const getLatestParams = {
  rules: getLatestParamRules,
  schema: validation.schema(getLatestParamRules),
}

export const getLatest = { params: getLatestParams }

const getParamRules = {
  id: validation.rules.string().required().label('Organization ID'),
  productEvaluationId: validation.rules.string().required().label('Product Evaluation ID'),
  productId: validation.rules.string().required().label('Product ID'),
}

const getParams = {
  rules: getParamRules,
  schema: validation.schema(getParamRules),
}

export const get = { params: getParams }

export const dismiss = { params: getParams }

const postParamRules = {
  id: validation.rules.string().required().label('Organization ID'),
  productId: validation.rules.string().required().label('Product ID'),
}

const postParams = {
  rules: postParamRules,
  schema: validation.schema(postParamRules),
}

export const post = { params: postParams }

// `apiKey` is OPTIONAL here on purpose: a missing key must reach the handler and be
// answered with 401, not turned into a 400 by the validate middleware.
const callbackQueryRules = { apiKey: validation.rules.string().optional().label('API Key') }

const callbackQuery = {
  rules: callbackQueryRules,
  schema: validation.schema(callbackQueryRules),
}

export const callback = {
  params: getParams,
  query: callbackQuery,
}
